import Phaser from 'phaser';

/** Tiny bootstrap scene: no assets needed; just transitions to Preload. */
export class BootScene extends Phaser.Scene {
  constructor() {
    super('boot');
  }
  create(): void {
    this.scene.start('preload');
  }
}
